import { RouteConfig } from 'vue-router';

import store from '@/store/store';
import { baseFilters } from '@/utils/baseFilters';
import PartnerEmployees from '@/views/employees/List.vue';
import EmployeeProfile from '@/views/employees/Profile.vue';
import UserRoles from '@/views/roles/roleAddUser.vue';

export const employeeListRoute: RouteConfig = {
  path: 'employees',
  name: 'employees',
  component: PartnerEmployees,
  beforeEnter: (to, from, next) => {
    store.dispatch('employees/list', baseFilters(to)).then(() => {
      store.commit('breadcrumbs/set', [{ text: 'Pracownicy', disabled: true }]);
      next();
    });
  },
  meta: { toolbarTitle: 'Pracownicy' }
};

export const employeeDetailsRoute: RouteConfig = {
  path: 'employees/:employeeId',
  name: 'employeePartner',
  component: EmployeeProfile,
  beforeEnter: (to, from, next) => {
    store.commit('employees/setId', to.params.employeeId);

    store
      .dispatch('employees/get')
      .then(res => {
        store.commit('breadcrumbs/set', [
          { text: 'Pracownicy', to: { name: 'employees' }, exact: true },
          { text: res.firstName && res.lastName ? res.firstName + ' ' + res.lastName : res.email, disabled: true }
        ]);
        next();
      })
      .catch(() => store.dispatch('notifyError', { title: 'Nie udało się pobrać danych pracownika' }));
  },
  meta: { toolbarTitle: 'Pracownik' }
};

export const employeeRolesRoute: RouteConfig = {
  path: '/employees/:id/roles',
  name: 'employeePartnerRoles',
  component: UserRoles,
  beforeEnter: (to, from, next) => {
    store.commit('employees/setId', to.params.id);

    Promise.all([
      store.dispatch(`profiles/userRole/list`, to.params.id),
      store.dispatch(`roles/list`, { count: 0 }),
      store.dispatch('employees/get').then(res => {
        store.commit('breadcrumbs/set', [
          { text: 'Pracownicy', to: { name: 'employees', exact: true } },
          {
            text: res.firstName && res.lastName ? res.firstName + ' ' + res.lastName : res.email,
            href: `/employees/${res.userId}`
          }
        ]);
      })
    ])
      .then(() => next())
      .catch(() => store.dispatch('notifyError', { title: 'Nie udało się pobrać danych pracownika' }));
  },
  meta: { toolbarTitle: 'Pracownik' }
};
